import React, { useEffect, useRef } from 'react'
import { useState } from 'react'
import { useAppDispatch as _useAppDispatch, useAppSelector } from '@/hooks'
import './index.less'
import 'leaflet/dist/leaflet.css'
import * as L from 'leaflet'
import { MapContainer, TileLayer, Marker as _Marker } from 'react-leaflet'
import { background } from '@/features/SetBackgroundColor/setBackgroundColor'
import { SRC_URL } from '@/server/apiConfig'
import _Position from '../Compare/Position'

interface MiniMapProps {
  //图片的tilesPath
  tilesPath: string
  //图片的宽
  width: number
  //图片的高
  height: number
  //图片的最大放缩level
  levelMax: number
  //图片的最小放缩level
  levelMin: number
}
function MiniMapTag(props: MiniMapProps) {
  const { tilesPath, width, height, levelMax, levelMin } = props
  // 控制瓦片地图显示url
  const [tileUrl, setTileUrl] = useState<string>('')
  const selectedRects = useAppSelector((state) => state.selectedRects.rects)
  // 获取背景颜色
  const backgroundColor = useAppSelector((state) => state.backgroundColor.analysisBackground)
  useEffect(() => {
    setTileUrl(SRC_URL + tilesPath + '/{z}/{x}/{y}.png')
  }, [tilesPath])
  // 瓦片地图ref
  const mapRef = useRef<L.Map | null>(null)
  // minimap's ref
  const miniMapRef = useRef()
  useEffect(() => {
    if (width === 0 || height === 0) return
    const timer = setTimeout(() => {
      //大图范围限制
      const map = mapRef.current
      if (!map) return
      map.invalidateSize()
      const mapSize = map.getSize()
      const fitZoom =
        mapSize.x > 0 && mapSize.y > 0
          ? Math.min(
              levelMax + Math.log2(mapSize.x / width),
              levelMax + Math.log2(mapSize.y / height)
            )
          : levelMin
      const initialZoom = Number.isFinite(fitZoom)
        ? Math.min(levelMin, Math.floor(fitZoom))
        : levelMin
      map.setMinZoom(initialZoom)
      map.setMaxZoom(levelMax)
      const southWest = map.unproject([-500, height + 500], map.getMaxZoom())
      const northEast = map.unproject([width + 500, -500], map.getMaxZoom())
      map.setMaxBounds(L.latLngBounds(southWest, northEast))
      const imageSouthWest = map.unproject([0, height], levelMax)
      const imageNorthEast = map.unproject([width, 0], levelMax)
      if (imageSouthWest && imageNorthEast) {
        map.fitBounds(L.latLngBounds(imageSouthWest, imageNorthEast), {
          animate: false,
          padding: [0, 0],
          maxZoom: levelMax
        })
      }
      //minimap的中心定位
      //@ts-ignore
      miniMapRef.current?.setMaxZoom(levelMax)
      //@ts-ignore
      const miniSouthWest = miniMapRef.current?.unproject(
        [-50, height + 50],
        //@ts-ignore
        miniMapRef.current?.getMaxZoom()
      )
      //@ts-ignore
      const miniNorthEast = miniMapRef.current?.unproject(
        [width + 50, -50],
        //@ts-ignore
        miniMapRef.current?.getMaxZoom()
      )
      //@ts-ignore
      miniMapRef.current?.setMaxBounds(L.latLngBounds(miniSouthWest, miniNorthEast))
    }, 0)
    return () => {
      clearTimeout(timer)
    }
  }, [width, height, levelMax, levelMin, tilesPath])

  useEffect(() => {
    const map = mapRef.current
    if (!map) return
    const updateRectWeight = (e: L.LeafletEvent) => {
      map.eachLayer((layer) => {
        const targetLayer = layer as any
        for (let i = 0; i < selectedRects.length; i++) {
          if (selectedRects[i].areaId === targetLayer._leaflet_id) {
            targetLayer.setStyle({ weight: 1 + Math.floor(e.target.getZoom() - levelMin) / 2 })
          }
        }
      })
    }
    map.on('zoomend', updateRectWeight)
    return () => {
      map.off('zoomend', updateRectWeight)
    }
  }, [levelMin, selectedRects])

  useEffect(() => {
    //@ts-ignore
    mapRef.current?.eachLayer((layer) => {
      const targetLayer = layer as any
      if (targetLayer._url === undefined) {
        //@ts-ignore
        mapRef.current?.removeLayer(targetLayer)
      }
    })
    for (let i = 0; i < selectedRects.length; i++) {
      if (selectedRects[i].areaId === -1) continue
      const southWest = L.latLng(
        selectedRects[i].areaBounds[0][0].lat,
        selectedRects[i].areaBounds[0][0].lng
      )
      const northEast = L.latLng(
        selectedRects[i].areaBounds[0][2].lat,
        selectedRects[i].areaBounds[0][2].lng
      )
      const bounds = L.latLngBounds(southWest, northEast)
      //@ts-ignore
      const rect = L.rectangle(bounds, { color: 'red', weight: 1 })
      //@ts-ignore
      rect._leaflet_id = selectedRects[i].areaId
      //@ts-ignore
      mapRef.current?.addLayer(rect)
    }
  }, [selectedRects])

  return (
    <div
      className='minimap-container'
      style={{
        backgroundImage:
          backgroundColor === background.SUN
            ? 'linear-gradient(to bottom, rgb(203, 198, 198), rgb(48, 45, 45))'
            : '',
        backgroundColor: backgroundColor === background.SUN ? '' : 'black'
      }}
    >
      <MapContainer
        //@ts-ignore
        ref={mapRef}
        crs={L.CRS.Simple}
        center={{ lat: 0, lng: 0 }}
        zoom={levelMin}
        style={{ height: '100%', width: '100%' }}
        dragging={true}
        doubleClickZoom={true}
        scrollWheelZoom={true}
        attributionControl={false}
        zoomControl={false}
        minZoom={-10}
        maxZoom={levelMax}
      >
        <TileLayer
          key={tileUrl}
          url={tileUrl}
          tileSize={512}
          noWrap={true}
          minZoom={-10}
          maxZoom={levelMax}
          minNativeZoom={levelMin}
          maxNativeZoom={levelMax}
        />
      </MapContainer>
    </div>
  )
}
export default React.memo(MiniMapTag)
